export var configurableProps = [/** 动态属性 */
'defaultType', 'showTraffic', 'showRoad'

/* 扩展属性 */];

export var allProps = configurableProps.concat([]);
export var setterMap = {
  visible: function visible(val, instance) {
    if (instance) {
      if (val) {
        instance.show();
      } else {
        instance.hide();
      }
    }
  }
};
export var converterMap = {};